module.exports = __webpack_public_path__ + "calendar-mobile.16eaa135b4755096b9c46784612bca57.png";